import { render, staticRenderFns } from "./vulnerability_list_graphql.vue?vue&type=template&id=67564e1a&"
import script from "./vulnerability_list_graphql.vue?vue&type=script&lang=js&"
export * from "./vulnerability_list_graphql.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports